import {
   Button,
   Flex,
   Image,
   Spacer,
   Text,
   Popover,
   PopoverTrigger,
   PopoverContent,
   PopoverBody,
   useDisclosure,
} from "@chakra-ui/react";
import { DivBox, ProfileMenu } from "./style";
import React, { memo, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getUserInfoAction, setUserInfoAction } from "../home-layout/profile/store/action";
import loginAuth from "../custom/login-auth";
import { setBotConfigListAction } from "../home-layout/yourbots/store/action";
function HomeHeaderComponent({ user_id, isLogin }) {
   const location = useLocation();
   const { onOpen, onClose, isOpen } = useDisclosure();
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const { twitter_screen_name, profile_image_url_https } = useSelector(
      (state) => ({
         twitter_screen_name: state.user.twitter_screen_name,
         profile_image_url_https: state.user.profile_image_url_https,
      }),
      shallowEqual
   );
   const bHomePage = location.pathname === "/";
   const bGetStart = location.pathname.indexOf("getstart") !== -1;
   const bDocPage = location.pathname.indexOf("doc") !== -1;
   useEffect(() => {
      if (isLogin) {
         dispatch(getUserInfoAction(user_id));
      }
   }, [dispatch, user_id, isLogin]);
   function showLoginedComponent() {
      return (
         <DivBox>
            <NavLink className="navlink" ml={66} to={`/${twitter_screen_name}/mybot`}>
               Your Bots
            </NavLink>
            <Popover isLazy placement="bottom-end" isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
               <PopoverTrigger>
                  <Image
                     borderRadius={"full"}
                     cursor={"pointer"}
                     w={"40px"}
                     h={"40px"}
                     ml={66}
                     fallbacksrc={process.env.REACT_APP_PUBLIC_URL + "iconfont/avatar_square.svg"}
                     src={profile_image_url_https}
                  />
               </PopoverTrigger>
               <PopoverContent
                  w={"180px"}
                  bgColor="#FFF"
                  border={"1px solid "}
                  borderColor={"#F1F1F1"}
                  outline={"none"}
                  _focus={{ boxShadow: "none" }}
                  boxShadow={"0px 2px 20px 10px rgba(0,0,0,0.05)"}>
                  <PopoverBody>
                     <ProfileMenu>
                        <Flex
                           className="menuitem"
                           id="profile"
                           onClick={() => {
                              navigate(`/${twitter_screen_name}/profile`);
                              onClose();
                           }}>
                           <Image w={"16px"} h={"16px"} />
                           <Text>Profile</Text>
                        </Flex>
                        <Flex
                           className="menuitem"
                           id="order"
                           onClick={() => {
                              navigate(`/${twitter_screen_name}/orderrecord`);
                              onClose();
                           }}>
                           <Image w={"16px"} h={"16px"} />
                           <Text>Order Record</Text>
                        </Flex>
                        <Flex
                           className="menuitem"
                           id="logout"
                           onClick={() => {
                              dispatch(setUserInfoAction(null));
                              dispatch(setBotConfigListAction(null));
                              navigate("/", { replace: true });
                              onClose();
                           }}>
                           <Image w={"16px"} h={"16px"} />
                           <Text>Logout</Text>
                        </Flex>
                     </ProfileMenu>
                  </PopoverBody>
               </PopoverContent>
            </Popover>
         </DivBox>
      );
   }
   function showNotLoginComponent() {
      return (
         <>
            <Text
               variant={"18_black"}
               cursor={"pointer"}
               _hover={{ color: "green.500" }}
               onClick={() => {
                  if (bHomePage) {
                     navigate("/", { state: { jump: true,type:'example' }, replace: true });
                  } else {
                     navigate("/", { state: { jump: true,type:'example' } });
                  }
               }}>
               Examples
            </Text>
            <Text
               _hover={{ color: "green.500" }}
               ml={66}
               variant={"18_black"}
               cursor={"pointer"}
               onClick={() => {
                  if (bHomePage) {
                     navigate("/", { state: { jump: true,type:'price' }, replace: true });
                  } else {
                     navigate("/", { state: { jump: true,type:'price' } });
                  }
               }}>
               Pricing
            </Text>
            <NavLink to={"/getstart"}>
               <Button
                  ml={66}
                  fontSize={16}
                  colorScheme={"green"}
                  boxShadow={"0px 16px 30px 0px rgba(201,239,226,0.8)"}
                  borderRadius={25}
                  h={"50px"}
                  w={"140px"}
                  color={"#FFF"}>
                  Get Started
               </Button>
            </NavLink>
         </>
      );
   }
   if (bDocPage) {
      return false;
   }
   return (
      <Flex
         flexDir={"row"}
         zIndex={1}
         px={"30px"}
         boxShadow={bHomePage || bGetStart ? "none" : "0px 2px 10px 0px rgba(0,0,0,0.05)"}>
         <Flex h={"86px"} w={"100%"} alignItems={"center"} justifyContent={"center"} marginX={"auto"}>
            <NavLink to={"/"}>
               <Image
                  userSelect={"none"}
                  src={process.env.REACT_APP_PUBLIC_URL + "iconfont/logo_icon.svg"}
                  w={"184px"}
                  h={"48px"}
               />
            </NavLink>
            <Spacer />
            {isLogin ? showLoginedComponent() : showNotLoginComponent()}
         </Flex>
      </Flex>
   );
}
export default memo(loginAuth(HomeHeaderComponent, false, "HomeHeaderComponent"));
